import React from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Breadcrumb, Table, Input, Select } from "antd";
import ButtonField from "../../common/htmlComponents/ButtonField";
import { Collapse } from "antd";
// import { getRequest } from "../../axios";

const VendorRFQMaterialDetails = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const navigate = useNavigate();
  const { Panel } = Collapse;
  const sitesArray = ["Ahmedabad", "Site2", "Site3", "Site4"];
  // const handleVendorChange = (value, record) => {
  //     // Handle the selection change here using the value and record
  //     // You can set the selected value to the record or perform other actions as needed
  // };
  const handleChange = (value) => {
  };

  const columns = [
    {
      title: "A",
      dataIndex: "A",
      key: "1",
      width: 50,
    },
    {
      title: "General cement",
      dataIndex: "Generalcement",
      key: "2",
    },
    ...sitesArray.map((site, index) => ({
      title: `Site ${index + 1}`,
      dataIndex: `SiteName${index + 1}`,
      key: `SiteName${index + 1}`,
      width: 150,
    })),

    // {
    //     title: 'Vendor',
    //     dataIndex: 'vendor',
    //     key: '6',
    //     render: (_, record) => (
    //         <>
    //             <Select
    //                 defaultValue=""
    //                 style={{ width: 120 }}
    //                 onChange={(value) => handleVendorChange(value, record)}
    //             >
    //                 {vendorOptions.map((option) => (
    //                     <Select.Option key={option.id} value={option.id}>
    //                         {option.first_name}
    //                     </Select.Option>
    //                 ))}
    //             </Select>
    //         </>
    //     ),
    // },
    {
      title: "TOTAL QTY.",
      dataIndex: "TOTAL",
      key: "4",
      width: 100,
    },
    {
      title: "unit rate",
      dataIndex: "unitrate",
      key: "3",
      width: 150,
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "22",
      width: 150,
    },
  ];
  const columns1 = [
    {
      title: "B",
      dataIndex: "B",
      key: "11",
      width: 50,
    },
    {
      title: "RMC",
      dataIndex: "rmc",
      key: "22",
    },
    ...sitesArray.map((site, index) => ({
      title: `Site ${index + 1}`,
      dataIndex: `SiteName${index + 1}`,
      key: `SiteName${index + 1}`,
      width: 150,
    })),

    {
      title: "TOTAL QTY.",
      dataIndex: "TOTAL",
      key: "44",
      width: 100,
    },
    {
      title: "unit rate",
      dataIndex: "unitrate",
      key: "33",
      width: 150,
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "22",
      width: 150,
    },
  ];
  const columns2 = [
    {
      title: "C",
      dataIndex: "C",
      key: "111",
      width: 50,
    },
    {
      title: "Special Cement",
      dataIndex: "specialcement",
      key: "222",
    },
    ...sitesArray.map((site, index) => ({
      title: `Site ${index + 1}`,
      dataIndex: `SiteName${index + 1}`,
      key: `SiteName${index + 1}`,
      width: 150,
    })),

    {
      title: "TOTAL QTY.",
      dataIndex: "TOTAL",
      key: "444",
      width: 100,
    },
    {
      title: "unit rate",
      dataIndex: "unitrate",
      key: "333",
      width: 150,
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "22",
      width: 150,
    },
  ];
  const columns3 = [
    {
      title: "D",
      dataIndex: "D",
      key: "1111",
      width: 50,
    },
    {
      title: "WBS Budget",
      dataIndex: "wbsbudget",
      key: "2222",
    },
    ...sitesArray.map((site, index) => ({
      title: `Site ${index + 1}`,
      dataIndex: `SiteName${index + 1}`,
      key: `SiteName${index + 1}`,
      width: 150,
    })),

    {
      title: "TOTAL QTY.",
      dataIndex: "TOTAL",
      key: "4444",
      width: 100,
    },
    {
      title: "unit rate",
      dataIndex: "unitrate",
      key: "3333",
      width: 150,
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "22",
      width: 150,
    },
  ];
  // const acolumns = [
  //     {
  //         title: "A",
  //         dataIndex: "A",
  //         key: "1",
  //         width: 50,
  //     },
  //     {
  //         title: "General cement",
  //         dataIndex: "Generalcement",
  //         key: "2",
  //     },
  //     {
  //         title: "Site name 1",
  //         dataIndex: "Sitename1",
  //         key: "3",
  //         width: 150,
  //     },
  //     {
  //         title: "Site name 2",
  //         dataIndex: "Sitename2",
  //         key: "4",
  //         width: 150,
  //     },
  //     {
  //         title: "Site name 3",
  //         dataIndex: "Sitename3",
  //         key: "5",
  //         width: 150,
  //     },
  //     {
  //         title: "Site name 4",
  //         dataIndex: "Sitename4",
  //         key: "6",
  //         width: 150,
  //     },

  //     {
  //         title: "TOTAL QTY.",
  //         dataIndex: "TOTAL",
  //         key: "8",
  //         width: 100,
  //     },
  //     {
  //         title: "UOM.",
  //         dataIndex: "UOM",
  //         key: "7",
  //         width: 150,
  //     },
  //     {
  //         title: "Amount",
  //         dataIndex: "amount",
  //         key: "22",
  //         width: 150,
  //     },
  // ];
  const adata = [
    {
      key: "1",
      A: "1",
      Generalcement: <label>OPC 43</label>,
      Sitename1: <Input placeholder="" />,
      Sitename2: <Input placeholder="" />,
      Sitename3: <Input placeholder="" />,
      Sitename4: <Input placeholder="" />,
      unitrate: <Input placeholder="250" />,
      UOM: (
        <Select
          defaultValue="MT"
          style={{
            width: 120,
          }}
          onChange={handleChange}
          options={[
            {
              value: "jack",
              label: "Jack",
            },
            {
              value: "lucy",
              label: "Lucy",
            },

            {
              value: "Yiminghe",
              label: "yiminghe",
            },
          ]}
        />
      ),
      TOTAL: "100",
      amount: <Input placeholder="5,00,000" />,
    },
    {
      key: "2",
      A: "2",
      Generalcement: <label>OPC 43</label>,
      Sitename1: <Input placeholder="" />,
      Sitename2: <Input placeholder="" />,
      Sitename3: <Input placeholder="" />,
      Sitename4: <Input placeholder="" />,
      unitrate: <Input placeholder="250" />,
      UOM: (
        <Select
          defaultValue="MT"
          style={{
            width: 120,
          }}
          onChange={handleChange}
          options={[
            {
              value: "jack",
              label: "Jack",
            },
            {
              value: "lucy",
              label: "Lucy",
            },

            {
              value: "Yiminghe",
              label: "yiminghe",
            },
          ]}
        />
      ),
      TOTAL: "100",
      amount: <Input placeholder="5,00,000" />,
    },
    {
      key: "3",
      A: "3",
      Generalcement: <label>OPC 43</label>,
      Sitename1: <Input placeholder="" />,
      Sitename2: <Input placeholder="" />,
      Sitename3: <Input placeholder="" />,
      Sitename4: <Input placeholder="" />,
      unitrate: <Input placeholder="250" />,
      UOM: (
        <Select
          defaultValue="MT"
          style={{
            width: 120,
          }}
          onChange={handleChange}
          options={[
            {
              value: "jack",
              label: "Jack",
            },
            {
              value: "lucy",
              label: "Lucy",
            },

            {
              value: "Yiminghe",
              label: "yiminghe",
            },
          ]}
        />
      ),
      TOTAL: "100",
      amount: <Input placeholder="5,00,000" />,
    },
    {
      key: "4",
      A: "4",
      Generalcement: <label>OPC 43</label>,
      Sitename1: <Input placeholder="" />,
      Sitename2: <Input placeholder="" />,
      Sitename3: <Input placeholder="" />,
      Sitename4: <Input placeholder="" />,
      unitrate: <Input placeholder="250" />,
      UOM: (
        <Select
          defaultValue="MT"
          style={{
            width: 120,
          }}
          onChange={handleChange}
          options={[
            {
              value: "jack",
              label: "Jack",
            },
            {
              value: "lucy",
              label: "Lucy",
            },
            {
              value: "Yiminghe",
              label: "yiminghe",
            },
          ]}
        />
      ),
      TOTAL: "100",
      amount: <Input placeholder="5,00,000" />,
    },
  ];
  const adata1 = [
    {
      key: "11",
      B: "1",
      rmc: <label>OPC 43</label>,
      Sitename1: <Input placeholder="" />,
      Sitename2: <Input placeholder="" />,
      Sitename3: <Input placeholder="" />,
      Sitename4: <Input placeholder="" />,
      unitrate: <Input placeholder="250" />,
      UOM: (
        <Select
          defaultValue="MT"
          style={{
            width: 120,
          }}
          onChange={handleChange}
          options={[
            {
              value: "jack",
              label: "Jack",
            },
            {
              value: "lucy",
              label: "Lucy",
            },

            {
              value: "Yiminghe",
              label: "yiminghe",
            },
          ]}
        />
      ),
      TOTAL: "100",
      amount: <Input placeholder="5,00,000" />,
    },
    {
      key: "22",
      B: "2",
      rmc: <label>OPC 43</label>,
      Sitename1: <Input placeholder="" />,
      Sitename2: <Input placeholder="" />,
      Sitename3: <Input placeholder="" />,
      Sitename4: <Input placeholder="" />,
      unitrate: <Input placeholder="250" />,
      UOM: (
        <Select
          defaultValue="MT"
          style={{
            width: 120,
          }}
          onChange={handleChange}
          options={[
            {
              value: "jack",
              label: "Jack",
            },
            {
              value: "lucy",
              label: "Lucy",
            },

            {
              value: "Yiminghe",
              label: "yiminghe",
            },
          ]}
        />
      ),
      TOTAL: "100",
      amount: <Input placeholder="5,00,000" />,
    },
    {
      key: "33",
      B: "3",
      rmc: <label>OPC 43</label>,
      Sitename1: <Input placeholder="" />,
      Sitename2: <Input placeholder="" />,
      Sitename3: <Input placeholder="" />,
      Sitename4: <Input placeholder="" />,
      unitrate: <Input placeholder="250" />,
      UOM: (
        <Select
          defaultValue="MT"
          style={{
            width: 120,
          }}
          onChange={handleChange}
          options={[
            {
              value: "jack",
              label: "Jack",
            },
            {
              value: "lucy",
              label: "Lucy",
            },

            {
              value: "Yiminghe",
              label: "yiminghe",
            },
          ]}
        />
      ),
      TOTAL: "100",
      amount: <Input placeholder="5,00,000" />,
    },
    {
      key: "44",
      B: "4",
      rmc: <label>OPC 43</label>,
      Sitename1: <Input placeholder="" />,
      Sitename2: <Input placeholder="" />,
      Sitename3: <Input placeholder="" />,
      Sitename4: <Input placeholder="" />,
      unitrate: <Input placeholder="250" />,
      UOM: (
        <Select
          defaultValue="MT"
          style={{
            width: 120,
          }}
          onChange={handleChange}
          options={[
            {
              value: "jack",
              label: "Jack",
            },
            {
              value: "lucy",
              label: "Lucy",
            },
            {
              value: "Yiminghe",
              label: "yiminghe",
            },
          ]}
        />
      ),
      TOTAL: "100",
      amount: <Input placeholder="5,00,000" />,
    },
  ];
  const adata2 = [
    {
      key: "111",
      C: "1",
      specialcement: <label>OPC 43</label>,
      Sitename1: <Input placeholder="" />,
      Sitename2: <Input placeholder="" />,
      Sitename3: <Input placeholder="" />,
      Sitename4: <Input placeholder="" />,
      unitrate: <Input placeholder="250" />,
      UOM: (
        <Select
          defaultValue="MT"
          style={{
            width: 120,
          }}
          onChange={handleChange}
          options={[
            {
              value: "jack",
              label: "Jack",
            },
            {
              value: "lucy",
              label: "Lucy",
            },

            {
              value: "Yiminghe",
              label: "yiminghe",
            },
          ]}
        />
      ),
      TOTAL: "100",
      amount: <Input placeholder="5,00,000" />,
    },
    {
      key: "222",
      C: "2",
      specialcement: <label>OPC 43</label>,
      Sitename1: <Input placeholder="" />,
      Sitename2: <Input placeholder="" />,
      Sitename3: <Input placeholder="" />,
      Sitename4: <Input placeholder="" />,
      unitrate: <Input placeholder="250" />,
      UOM: (
        <Select
          defaultValue="MT"
          style={{
            width: 120,
          }}
          onChange={handleChange}
          options={[
            {
              value: "jack",
              label: "Jack",
            },
            {
              value: "lucy",
              label: "Lucy",
            },

            {
              value: "Yiminghe",
              label: "yiminghe",
            },
          ]}
        />
      ),
      TOTAL: "100",
      amount: <Input placeholder="5,00,000" />,
    },
    {
      key: "333",
      C: "3",
      specialcement: <label>OPC 43</label>,
      Sitename1: <Input placeholder="" />,
      Sitename2: <Input placeholder="" />,
      Sitename3: <Input placeholder="" />,
      Sitename4: <Input placeholder="" />,
      unitrate: <Input placeholder="250" />,
      UOM: (
        <Select
          defaultValue="MT"
          style={{
            width: 120,
          }}
          onChange={handleChange}
          options={[
            {
              value: "jack",
              label: "Jack",
            },
            {
              value: "lucy",
              label: "Lucy",
            },

            {
              value: "Yiminghe",
              label: "yiminghe",
            },
          ]}
        />
      ),
      TOTAL: "100",
      amount: <Input placeholder="5,00,000" />,
    },
    {
      key: "444",
      C: "4",
      specialcement: <label>OPC 43</label>,
      Sitename1: <Input placeholder="" />,
      Sitename2: <Input placeholder="" />,
      Sitename3: <Input placeholder="" />,
      Sitename4: <Input placeholder="" />,
      unitrate: <Input placeholder="250" />,
      UOM: (
        <Select
          defaultValue="MT"
          style={{
            width: 120,
          }}
          onChange={handleChange}
          options={[
            {
              value: "jack",
              label: "Jack",
            },
            {
              value: "lucy",
              label: "Lucy",
            },
            {
              value: "Yiminghe",
              label: "yiminghe",
            },
          ]}
        />
      ),
      TOTAL: "100",
      amount: <Input placeholder="5,00,000" />,
    },
  ];
  const adata3 = [
    {
      key: "1111",
      D: "1",
      wbsbudget: <label>OPC 43</label>,
      Sitename1: <Input placeholder="" />,
      Sitename2: <Input placeholder="" />,
      Sitename3: <Input placeholder="" />,
      Sitename4: <Input placeholder="" />,
      unitrate: <Input placeholder="250" />,
      UOM: (
        <Select
          defaultValue="MT"
          style={{
            width: 120,
          }}
          onChange={handleChange}
          options={[
            {
              value: "jack",
              label: "Jack",
            },
            {
              value: "lucy",
              label: "Lucy",
            },

            {
              value: "Yiminghe",
              label: "yiminghe",
            },
          ]}
        />
      ),
      TOTAL: "100",
      amount: <Input placeholder="5,00,000" />,
    },
    {
      key: "2222",
      D: "2",
      wbsbudget: <label>OPC 43</label>,
      Sitename1: <Input placeholder="" />,
      Sitename2: <Input placeholder="" />,
      Sitename3: <Input placeholder="" />,
      Sitename4: <Input placeholder="" />,
      unitrate: <Input placeholder="250" />,
      UOM: (
        <Select
          defaultValue="MT"
          style={{
            width: 120,
          }}
          onChange={handleChange}
          options={[
            {
              value: "jack",
              label: "Jack",
            },
            {
              value: "lucy",
              label: "Lucy",
            },

            {
              value: "Yiminghe",
              label: "yiminghe",
            },
          ]}
        />
      ),
      TOTAL: "100",
      amount: <Input placeholder="5,00,000" />,
    },
    {
      key: "3333",
      D: "3",
      wbsbudget: <label>OPC 43</label>,
      Sitename1: <Input placeholder="" />,
      Sitename2: <Input placeholder="" />,
      Sitename3: <Input placeholder="" />,
      Sitename4: <Input placeholder="" />,
      unitrate: <Input placeholder="250" />,
      UOM: (
        <Select
          defaultValue="MT"
          style={{
            width: 120,
          }}
          onChange={handleChange}
          options={[
            {
              value: "jack",
              label: "Jack",
            },
            {
              value: "lucy",
              label: "Lucy",
            },

            {
              value: "Yiminghe",
              label: "yiminghe",
            },
          ]}
        />
      ),
      TOTAL: "100",
      amount: <Input placeholder="5,00,000" />,
    },
    {
      key: "4444",
      D: "4",
      wbsbudget: <label>OPC 43</label>,
      Sitename1: <Input placeholder="" />,
      Sitename2: <Input placeholder="" />,
      Sitename3: <Input placeholder="" />,
      Sitename4: <Input placeholder="" />,
      unitrate: <Input placeholder="250" />,
      UOM: (
        <Select
          defaultValue="MT"
          style={{
            width: 120,
          }}
          onChange={handleChange}
          options={[
            {
              value: "jack",
              label: "Jack",
            },
            {
              value: "lucy",
              label: "Lucy",
            },
            {
              value: "Yiminghe",
              label: "yiminghe",
            },
          ]}
        />
      ),
      TOTAL: "100",
      amount: <Input placeholder="5,00,000" />,
    },
  ];

  const thead = <Table columns={columns} />;
  const thead1 = <Table columns={columns1} />;
  const thead2 = <Table columns={columns2} />;
  const thead3 = <Table columns={columns3} />;

  const onChange = (key) => {
  };
  return (
    <>
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
            <h3> RFQ - Material Details - Vendor</h3>

            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/dashboard">{t("home")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>Float RFQ</Breadcrumb.Item>
              <Breadcrumb.Item>RFQ - Material Details - Vendor</Breadcrumb.Item>
            </Breadcrumb>
          </div>
        </div>
      </div>
      <section className="grid-sec mt-5">
        <div className="PR-body">
          <h5 className="rfq-number new">
            RFQ Number : <span>RFQ-CO1-001</span>
          </h5>
          <Collapse defaultActiveKey={["1"]} onChange={onChange}>
            <Panel header={thead} key="1">
              <Table columns={columns} dataSource={adata} pagination={false} />
            </Panel>
            <Panel header={thead1} key="2">
              <Table
                columns={columns1}
                dataSource={adata1}
                pagination={false}
              />
            </Panel>
            <Panel header={thead2} key="3">
              <Table
                columns={columns2}
                dataSource={adata2}
                pagination={false}
              />
            </Panel>
            <Panel header={thead3} key="4">
              <Table
                columns={columns3}
                dataSource={adata3}
                pagination={false}
              />
            </Panel>
          </Collapse>
          <div className="btnwrp">
            {/* <ButtonField
                            className="CancelGradiantBtn"
                            type="primary"
                            htmlType="Cancel"
                            label="Cancel"
                        /> */}
            <ButtonField
              className="SaveGradiantBtn"
              type="primary"
              htmlType="Previous"
              label="Previous"
              onClick={() => navigate(`/vendor-request-for-quotation/history/${id}`)}
            />
            <ButtonField
              className="SaveGradiantBtn"
              type="primary"
              htmlType="Select Vendor"
              label="Submit BID"
              onClick={() => navigate(`/vendor-request-for-quotation/bid-rfq/${id}`)}
            />
          </div>
        </div>
      </section>
    </>
  );
};
export default VendorRFQMaterialDetails;
